import { render } from "./AppStore.vue?vue&type=template&id=535ac82a"
import script from "./AppStore.vue?vue&type=script&lang=js"
export * from "./AppStore.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__